import { Content } from '@prismicio/client';
import { Simplify } from '../../../../../prismicio-types';
import { Sloping } from '@/assets';
import styles from './SlideCard.module.scss';

interface Props {
  card: Simplify<Content.ExtendedTestimonialsSliceDefaultPrimaryTestimonialsItem>;
}

const SlideCard = ({ card }: Props) => {
  return (
    <div className={styles.card}>
      <div className={styles.testimonial}>
        <p className={styles.text}>{card.text}</p>
        <span className={styles.name}>{card.client_name}</span>
      </div>
      <div className={styles.line} />
      <div className={styles.plate}>
        <div className={styles.plate_content}>
          <span className={styles.loan_amount}>
            {card.loan_amount_received}
          </span>
          <span className={styles.plate_text}>{card.plate_text}</span>
        </div>
        <Sloping />
      </div>
    </div>
  );
};

export default SlideCard;
